import { lazy } from 'react';

export const ConfirmEmailPage = lazy(() => import('./ConfirmEmailPage'));
